var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{attrs:{"data-styler":""},on:{"change":function($event){return _vm.changeViewSettings()}}},[_c('option',[_vm._v(_vm._s(_vm.decodedData))])])}
var staticRenderFns = []

export { render, staticRenderFns }